import React, {Component} from 'react';
import PadraoNacional from '../../../assets/documents/padrao-nacional-da-cie-2025-vf.pdf'
import {Link} from 'react-router-dom';

const scrollPage = (props) => {
  const currentPage = props.match.params.page;

  let element;
  let topToScroll = 0;

  if (currentPage !== "") {
    if (currentPage === "padraonacional") {
      element = document.getElementById('padraoNacional');
      topToScroll = (element.offsetTop - 140);
    } else if (currentPage === "comocomunicar") {
      element = document.getElementById('comoComunicar');
      topToScroll = (element.offsetTop - 120);
    }
  }

  window.scrollTo(0, topToScroll);
};

export default class Lei extends Component {
  componentDidUpdate() {
    scrollPage(this.props);
  }

  componentDidMount() {
    scrollPage(this.props);
  }

  render() {
    return (
      <div>
        <section className="aLei bg-blue-meiaentrada divisao-sessao divisao-sessao-bottom py-5 text-light">
          <div className="meiaentrada-title mb-5">
            <div className="container">
              <div className="meiaentrada-title-border-hide">
                <h1>Lei da Meia-entrada</h1>
              </div>
            </div>
          </div>
          <div className="container">
            <p>
              Em 05 de agosto de 2013, foi publicada a Lei Federal nº 12.852/2013 que cria o “Estatuto da Juventude”,
              dispondo sobre os direitos dos jovens e os princípios das políticas públicas de juventude, garantindo o
              acesso à cultura como uma de suas diretrizes fundamentais. Para proporcionar tal acesso, a lei assegura
              o direito à meia-entrada, possibilitando aos estudantes o pagamento do ingresso pela metade de seu valor,
              mediante a apresentação da Carteira de Identificação Estudantil (CIE).
            </p>
            <p>
              Neste contexto, a Lei Federal nº 12.933/2013 trata especificamente sobre o benefício ao pagamento de
              meia-entrada em espetáculos artísticos, culturais e esportivos, trazendo outras regras para o exercício
              regular e efetivo do direito. A lei reitera o direito à meia-entrada mediante a apresentação da <a
              href="http://www.documentodoestudante.com.br?utm_source=http://meiaentrada.org.br&utm_medium=referral&utm_campaign=leidaentraentrada"
              target="_blank" rel="noopener noreferrer"> Carteira de Identificação Estudantil</a> (CIE),
              emitida conforme modelo único nacionalmente padronizado e publicamente disponibilizado pela
              <a href="https://www.anpg.org.br/lp/meia-entrada/?utm_source=http://meiaentrada.org.br&amp;utm_medium=referral&amp;utm_campaign=leidaentraentrada" target="_blank" rel="noopener noreferrer"> Associação Nacional de Pós-Graduandos </a>
 (ANPG), pela <a href="https://www.une.org.br/lp/carteira-de-estudante-oficial/?utm_source=http://meiaentrada.org.br&amp;utm_medium=referral&amp;utm_campaign=leidaentraentrada" target="_blank" rel="noopener noreferrer"> União Nacional dos Estudantes </a>
 (UNE), pela <a href="https://ubes.org.br/lp/carteira-de-estudante-2022/?utm_source=http://meiaentrada.org.br&utm_medium=referral&utm_campaign=leidaentraentrada" target="_blank" rel="noopener noreferrer"> União Brasileira dos Estudantes Secundaristas </a>
               (UBES)
              e pelo Instituto Nacional de Tecnologia da Informação (ITI), este último responsável pela definição dos
              parâmetros da certificação digital da carteira.
            </p>
            <p>
              Regulamentando ambas as leis, o decreto federal nº 8.537/2015 reafirma a necessidade de emissão da
              Carteira de Identificação Estudantil (CIE) conforme modelo único nacionalmente padronizado e com
              certificação digital, visando evitar a criação de documentos falsos, a emissão por entidades não
              autorizadas e fraudes.
            </p>
            <p>
              Mais do que simplesmente padronizar a Carteira de Identificação Estudantil (CIE), as normas em vigor
              exigem dos estabelecimentos responsáveis pelos eventos a necessidade de comunicação, de forma clara e
              ostensiva, sobre quais são os requisitos para a concessão do benefício da meia-entrada, e o exijam para
              que o estudante faça jus ao citado benefício. A Lei n. 13.179/2015, por sua vez, estende este dever de
              comunicação a todas as formas de comercialização de ingressos on-line.
            </p>
          </div>
        </section>

        <section className="padraoNacional py-4" id='padraoNacional'>
          <div className="meiaentrada-title mb-5">
            <div className="container">
              <div className="meiaentrada-title-border-hide">
                <h2>Padrão Nacional</h2>
              </div>
            </div>
          </div>
          <div className="container">
            <p>
              Conforme previsto em lei nº 12.933/2013, as entidades nacionais de representação estudantil estabeleceram um modelo de
              padronização para a emissão da Carteira de Identificação Estudantil (CIE), o que envolve a elaboração e layout da
              Carteira, seu processo de emissão e a inserção das informações cadastrais do estudantes no certificado de atributo, onde esse, é assinado pelo certificado digital A3 da entidade estudantil, possibilitando
              a consulta pública para sua respectiva validação.
            </p>

            <p>
              O padrão nacional para emissão da Carteira de Identificação Estudantil (CIE) pode ser acessado abaixo:
            </p>

            <div className="text-center my-5">
              <a
                href={PadraoNacional}
                target='blank' className="btn btn-success btn-lg">
                  Padrão Nacional - {new Date().getFullYear()}
              </a>
            </div>

            <p>
              No que se refere à padronização do certificado digital por parte do Instituto Nacional de Tecnologia e Informação (ITI), este órgão expediu a Portaria no. 78, de 24 de dezembro de 2018, disponível para consulta no site <Link to='http://www.iti.gov.br' target='blank'>www.iti.gov.br</Link>.
            </p>
          </div>
        </section>

        <section className="bg-blue-meiaentrada divisao-sessao divisao-sessao-top pt-2 pb-5 text-light"
                 id='comoComunicar'>
          <div className="meiaentrada-title mb-5">
            <div className="container">
              <div className="meiaentrada-title-border-hide">
                <h2>Como comunicar</h2>
              </div>
            </div>
          </div>
          <div className="container">
            <p>
              Os estabelecimentos, as produtoras e as promotoras de eventos devem disponibilizar, de forma clara e
              ostensiva, as seguintes informações:
            </p>

            <ul>
              <li>
                A transcrição do art. 1º da Lei nº 12.933, de 2013, sobre as condições estabelecidas para o gozo da
                meia-entrada
              </li>
              <li>Os elementos ou foto da Carteira de Identificação Estudantil (CIE)</li>
              <li>Os telefones dos órgãos de fiscalização</li>
            </ul>

            <p>
              Essas informações devem estar disponíveis em todos os pontos de venda de ingresso, sejam eles físicos ou
              virtuais, e na portaria ou na entrada do local de realização do evento, antes de consumada a venda.
            </p>

            <p>
              Não se admite que tais informações estejam apenas em áreas do site não relacionadas à venda dos ingressos,
              como por exemplo “políticas de venda” ou “termos de uso”; as informações precisam estar dispostas de forma
              clara para que o estudante-consumidor tenha acesso a elas antes da realização de sua compra.
            </p>

            {/*<p>*/}
              {/*As entidades nacionais de representação estudantil disponibilizam <Link to="/">mídia kits</Link>, com*/}
              {/*sugestões de peças de comunicação para informar o público sobre o benefício da meia-entrada, tanto no*/}
              {/*ambiente online quanto nas bilheterias e portarias.*/}
            {/*</p>*/}
          </div>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/views/ALei/ALei.js